import { render, staticRenderFns } from "./AnnouncementDisplay.vue?vue&type=template&id=350c4bca&scoped=true"
import script from "./AnnouncementDisplay.vue?vue&type=script&lang=ts"
export * from "./AnnouncementDisplay.vue?vue&type=script&lang=ts"
import style0 from "./AnnouncementDisplay.vue?vue&type=style&index=0&id=350c4bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350c4bca",
  null
  
)

export default component.exports